[
  {
    "url": "https://docs.google.com/spreadsheets/d",
    "elements": [
      {
        "name": "Cell data",
        "selector": ".cell-input"
      }
    ]
  }
]
